import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

import { RadioGroupContext } from 'contexts';

const RadioGroup = ({
  name,
  label,
  value: valueProp,
  disabled: disabledProp,
  onChange,
  children,
  className,
}) => {
  const [value, setValueState] = useState(valueProp);

  const handleChange = useCallback(
    (event) => {
      setValueState(event.target.value);

      if (onChange) {
        onChange(event.target.value);
      }
    },
    [onChange],
  );

  const contextValue = useMemo(
    () => ({
      name,
      value: valueProp,
      onChange: handleChange,
      disabled: disabledProp,
    }),
    [name, valueProp, handleChange, disabledProp],
  );

  return (
    <RadioGroupContext.Provider value={contextValue}>
      <fieldset>
        <Form.Group className={className}>
          {label && <Form.Label>{label}</Form.Label>}
          {children}
        </Form.Group>
      </fieldset>
    </RadioGroupContext.Provider>
  );
};

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

RadioGroup.defaultProps = {
  onChange: () => {},
  disabled: false,
};

export default RadioGroup;
